import { useForm } from "@formspree/react";
import AOS from "aos";
import "aos/dist/aos.css";
import React, { useEffect } from "react";
import { Container } from "react-bootstrap";
import "./Contact.scss";

const Contact = () => {
  const [state, handleSubmit] = useForm("moqyjllr");
  if (state.succeeded) {
    console.log(state.succeeded);
    alert("Thank you for sending massage!");
  }
  useEffect(() => {
    AOS.init({ duration: 2000 });
  }, []);
  return (
    <div id="contact">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 220">
        <path
          fill="#100028"
          fillOpacity="1"
          d="M0,160L1440,96L1440,320L0,320Z"
        ></path>
      </svg>
      <div className="bg-color">
        <Container className="pt-5">
        <h1 data-aos="fade-up" style={{ color: "#ffffff" }} className="text-center mb-4 mb-md-5 headline">
          GET IN TOUCH
        </h1>
        <div className="col-md-9 mx-auto">
          <form onSubmit={handleSubmit}>
            <div data-aos="fade-up" className="form-group">
              <input
                type="email"
                name="email"
                className="form-control"
                placeholder="Email Address *"
              />
            </div>
            <div data-aos="fade-up" className="form-group">
              <input
                type="text"
                name="subject"
                className="form-control"
                placeholder="Subject *"
              />
            </div>
            <div data-aos="fade-up" className="form-group">
              <textarea
                name="message"
                className="form-control"
                id=""
                cols="30"
                rows="10"
                placeholder="Message *"
              ></textarea>
            </div>
            <div data-aos="fade-up" className="text-center pb-4 pt-3">
              <button type="submit" className="contact-btn">
                Send
              </button>
            </div>
          </form>
        </div>
      </Container>
      </div>
    </div>
  );
};

export default Contact;
